import {initialState,initialMutations,initialActions} from "./common_store";

let defaultState = {
    url_name: 'multiple-arrival-departure'
};

defaultState = {...initialState, ...defaultState};
defaultState = JSON.parse(JSON.stringify(defaultState));

const getters = {
    reportLoading: state => state.loading,
};

const actions = {...initialActions};

const mutations = {...initialMutations};

export default {
    namespaced: true,
    state: defaultState,
    getters,
    actions,
    mutations
}
